import * as React from 'react'
import PropTypes from 'prop-types'
import Badge from "../Badge"

export const studyTypeMap = {
  "Interventional": {
    label: "Int",
    colorName: "yellow",
  },
  "Observational": {
    label: "Obs",
    colorName: "blue",
  },
  "Expanded Access": {
    label: "Exp",
    colorName: "orange",
  }
}

const StudyTypeBadge = ({
  value,
  style = {},
}) => {
  if (!value) return null;

  return <Badge
    value={studyTypeMap?.[value]?.label}
    tooltipText={value}
    colorName={studyTypeMap?.[value]?.colorName}
    style={{ ...style, width: 38 }}
  />
}

StudyTypeBadge.propTypes = {
  value: PropTypes.oneOf([
    "Interventional",
    "Observational",
    "Expanded Access",
  ]),
}

export default StudyTypeBadge